import cx from 'clsx';
import React, { FunctionComponent } from 'react';
import styles from './Block.module.scss';

interface OwnProps {
  width?: 'container' | 'full';
  backgroundWidth?: 'container' | 'full';
  direction?: 'column' | 'row';
  theme?: 'light' | 'grey' | 'dark' | 'green' | 'white';
}

type BlockProps = JSX.IntrinsicElements['section'] & OwnProps;

const Block: FunctionComponent<BlockProps> = props => {
  const { width = false, backgroundWidth = 'full', theme = 'white', direction = 'column', className, children, ...rest } = props;

  const blockClassName = cx({
    [styles.block]: true,
    [styles.backgroundWidth]: backgroundWidth === 'full',
    ...(theme && { [styles[theme]]: true }),
    ...(className && { [className]: true }),
  });

  const blockWrapperClassName = cx({
    [styles.wrapper]: true,
    [styles.full]: width === 'full',
    [styles[direction]]: true,
  });

  return (
    <section className={blockClassName} {...rest}>
      <div className={blockWrapperClassName}>{children}</div>
    </section>
  );
};

export default Block;
